/* ==========================================================================
   pdp.js — Product Detail Page behaviour (Fine Scrubs) — reference-faithful
   Vanilla JS (no jQuery dependency of its own). Loaded only on product templates.
   Real variant/price/image binding still flows through the theme's
   Shopify.OptionSelectors + selectCallback (see sections/product-template.liquid);
   this file adds the redesign chrome:
     - Quantity stepper (− / +)
     - AJAX add-to-cart + minicart refresh + button state machine
     - Star rendering for [data-rating]
     - Selector "chosen" echoes + extended-size note
     - Delivery date ranges
     - Savings pill (initial + exposed recompute for selectCallback)
     - ARIA tabs (details) with arrow-key nav
     - Size-guide modal: dialog + focus trap + Esc + Men/Women/Unisex tabs
     - Sticky add-to-cart bar via IntersectionObserver
     - Judge.me "Write a review" passthrough
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('.pdp-v2');
  if (!root) return;

  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  /* ---------------------------------------------------------------------- */
  /* 1. Quantity stepper                                                     */
  /* ---------------------------------------------------------------------- */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp-qty__btn');
    if (!btn) return;
    var wrap = btn.closest('.pdp-qty');
    var input = wrap && wrap.querySelector('#Quantity');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    if (btn.dataset.step === 'down') val = Math.max(min, val - 1);
    else val = val + 1;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------------------- */
  /* 2. Star rendering for any [data-rating] container                       */
  /* ---------------------------------------------------------------------- */
  function starSVG(fill) {
    return '<svg viewBox="0 0 24 24" fill="' + (fill ? 'currentColor' : 'none') +
      '" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 17.6 6.8 20.2l1-5.8L3.5 9.2l5.9-.9z"/></svg>';
  }
  $$('.pdp-stars[data-rating]').forEach(function (el) {
    var val = parseFloat(el.getAttribute('data-rating')) || 0;
    var html = '';
    for (var i = 1; i <= 5; i++) html += starSVG(i <= Math.round(val));
    el.innerHTML = html;
  });

  /* ---------------------------------------------------------------------- */
  /* 3. Delivery date ranges (vendor-conditional spans set in Liquid)        */
  /* ---------------------------------------------------------------------- */
  function formatDate(date) {
    return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }
  function setDateRange(id, fromDays, toDays) {
    var el = document.getElementById(id);
    if (!el) return;
    var from = new Date(); from.setDate(from.getDate() + fromDays);
    var to = new Date();   to.setDate(to.getDate() + toDays);
    el.textContent = formatDate(from) + ' – ' + formatDate(to);
  }
  setDateRange('monogram-range', 14, 17);
  setDateRange('simple-range', 5, 7);
  setDateRange('fashion-range', 6, 7);
  setDateRange('medline-range', 3, 5);

  /* ---------------------------------------------------------------------- */
  /* 4. Savings pill — exposed so selectCallback can recompute on variant swap */
  /* ---------------------------------------------------------------------- */
  window.pdpUpdateSavePill = function (price, compareAt) {
    root.querySelectorAll('.enj-save-pill').forEach(function (pill) {
      if (compareAt && compareAt > price) {
        pill.textContent = 'Save ' + Math.round((compareAt - price) / compareAt * 100) + '%';
        pill.classList.add('is-visible');
      } else {
        pill.classList.remove('is-visible');
      }
    });
  };
  (function initPill() {
    var pill = $('.enj-save-pill');
    if (!pill) return;
    var price = parseInt(pill.dataset.price, 10);
    var cmp = parseInt(pill.dataset.compare, 10);
    if (!isNaN(price) && !isNaN(cmp)) window.pdpUpdateSavePill(price, cmp);
  })();

  /* ---------------------------------------------------------------------- */
  /* 5. Selector "chosen" echoes + selected-variant summary + ext-size note  */
  /*    Minimum variant price is used to detect a per-variant surcharge.     */
  /* ---------------------------------------------------------------------- */
  var minVariantPrice = (function () {
    var min = Infinity;
    $$('#productSelect option[value]').forEach(function (o) {
      // option text ends with the money-formatted price; we only need the id list,
      // so instead read the data-price rendered on the save pill as the base.
    });
    var pill = $('.enj-save-pill');
    if (pill && pill.dataset.price) min = parseInt(pill.dataset.price, 10);
    return isFinite(min) ? min : 0;
  })();

  // Color option values can encode extra data, e.g. "Peacock - NBT - #0375A9"
  // (name · clinical code · hex) or "Jade Green - #00A86B" (name · hex).
  function valueParts(v) { return String(v).split(/\s-\s/).map(function (s) { return s.trim(); }); }
  function isColorValue(v) { return /#[0-9a-f]{3,8}\b/i.test(v); }
  function cleanName(v) { return valueParts(v)[0]; }
  function colorCode(v) {
    var p = valueParts(v);
    if (p.length >= 3 && /^#/.test(p[p.length - 1])) return p[p.length - 2];
    return '';
  }

  function updateChosenEchoes() {
    $$('.swatch').forEach(function (sw) {
      var idx = sw.getAttribute('data-option-index');
      var checked = sw.querySelector('input[type="radio"]:checked');
      if (idx === null || !checked) return;
      var raw = checked.value;
      var echo = root.querySelector('.chosen[data-echo="' + idx + '"]');
      if (echo) echo.textContent = cleanName(raw);
      // Clinical color code caption (shown only for color values that carry a code)
      var selector = sw.closest('.pdp-selector');
      var cap = selector && selector.querySelector('[data-color-caption]');
      if (cap) {
        var code = isColorValue(raw) ? colorCode(raw) : '';
        var codeEl = cap.querySelector('[data-color-code]');
        if (code) { if (codeEl) codeEl.textContent = code; cap.hidden = false; }
        else { cap.hidden = true; }
      }
    });
    // Combined summary line (clean names)
    var summary = $('.pdp-selected-summary');
    if (summary) {
      var parts = [];
      $$('.swatch').forEach(function (sw) {
        var title = sw.querySelector('.title_variant');
        var checked = sw.querySelector('input[type="radio"]:checked');
        if (!checked) return;
        var label = title ? title.textContent.trim().replace(/\s+/g, ' ') : '';
        parts.push((label ? label + ': ' : '') + cleanName(checked.value));
      });
      summary.textContent = parts.join(' · ');
    }
  }

  // Ensure every color chip shows its color even when the theme's swatch style
  // didn't inline a background (the value carries the hex).
  function parseHex(v) {
    var last = valueParts(v).pop();
    return /^#[0-9a-f]{3,8}$/i.test(last) ? last : '';
  }
  $$('.maxus-color.color').forEach(function (el) {
    var input = el.querySelector('input[type="radio"]');
    if (!input) return;
    var hex = parseHex(input.value);
    var chip = el.querySelector('.color_style1, .link_color, .bg_image') || el.querySelector('label');
    if (chip && hex && !chip.style.backgroundColor) chip.style.backgroundColor = hex;
  });

  // Exposed so the theme's selectCallback can refresh the note after a variant swap.
  window.pdpUpdateExtNote = function (variantPrice) {
    var note = $('[data-ext-note]');
    if (!note) return;
    note.classList.toggle('show', minVariantPrice > 0 && variantPrice > minVariantPrice);
  };

  root.addEventListener('change', function (e) {
    if (e.target.matches('.swatch input[type="radio"]')) updateChosenEchoes();
  });
  updateChosenEchoes();

  /* ---------------------------------------------------------------------- */
  /* 6. AJAX add-to-cart + minicart refresh + button state machine           */
  /* ---------------------------------------------------------------------- */
  var live = $('.pdp-live');
  function announce(msg) { if (live) live.textContent = msg; }

  function setButtonState(form, state) {
    var btn = form.querySelector('.add-to-cart-change, .btn-add-stickycart');
    if (!btn) return;
    if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
    if (state === 'adding') {
      btn.disabled = true;
      btn.innerHTML = 'Adding… <span class="pdp-atc-spinner" aria-hidden="true"></span>';
    } else if (state === 'added') {
      btn.disabled = false;
      btn.classList.add('is-added');
      btn.textContent = 'Added ✓';
      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.textContent = btn.dataset.label;
      }, 1500);
    } else {
      btn.disabled = false;
      btn.textContent = btn.dataset.label;
    }
  }

  function refreshMiniCart() {
    var minicart = document.querySelector('.js-minicart');
    if (minicart) minicart.classList.add('active');
    var bg = document.querySelector('.js-bg');
    if (bg) bg.classList.add('active');

    fetch('/?section_id=cart-mini')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newContent = tmp.querySelector('.enj-minicart-ajax');
        var container = document.querySelector('.enj-minicart-ajax');
        if (newContent && container) container.innerHTML = newContent.innerHTML;

        var newCount = tmp.querySelector('.enj-cartcount');
        if (newCount) {
          var bubble = document.querySelector('.count_pr_incart');
          if (bubble) bubble.textContent = newCount.textContent.trim();
          document.querySelectorAll('.enj-cartcount').forEach(function (el) {
            el.innerHTML = newCount.innerHTML;
          });
        }
      })
      .catch(function () { /* minicart refresh is best-effort */ });
  }

  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      setButtonState(form, 'adding');
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : r.json().then(function (er) { return Promise.reject(er); }); })
        .then(function () {
          setButtonState(form, 'added');
          announce('Added to cart');
          refreshMiniCart();
        })
        .catch(function (err) {
          setButtonState(form, 'idle');
          announce('Could not add to cart');
          alert((err && err.description) || 'Something went wrong adding to cart.');
        });
    });
  });

  // Close minicart (preserve existing selectors)
  document.body.addEventListener('click', function (e) {
    if (e.target.closest('.close-mini-cart') || e.target.classList.contains('bg-minicart')) {
      var mc = document.querySelector('.js-minicart'); if (mc) mc.classList.remove('active');
      var bg = document.querySelector('.js-bg'); if (bg) bg.classList.remove('active');
    }
  });

  /* ---------------------------------------------------------------------- */
  /* 7. Details ARIA tabs (arrow-key nav) + size-chart tabs                   */
  /* ---------------------------------------------------------------------- */
  function setupTabs(listEl) {
    if (!listEl) return;
    var tabs = $$('[role="tab"]', listEl);
    function activate(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) { panel.classList.toggle('active', on); panel.hidden = !on; }
      });
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activate(tab); });
      tab.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(tab), n;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); n = (i + 1) % tabs.length; }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); n = (i - 1 + tabs.length) % tabs.length; }
        else return;
        tabs[n].focus(); activate(tabs[n]);
      });
    });
  }
  $$('.tablist').forEach(setupTabs);

  /* ---------------------------------------------------------------------- */
  /* 8. Size-guide modal: open/close + focus trap + Esc                       */
  /* ---------------------------------------------------------------------- */
  var modal = document.getElementById('pdpSizeModal');
  if (modal) {
    setupTabs(modal.querySelector('.sc-tabs'));
    var lastFocus = null;
    var FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    function openModal() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      // next frame so the transition runs
      requestAnimationFrame(function () { modal.classList.add('open'); });
      var closeBtn = modal.querySelector('[data-close-sizeguide]');
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKeydown);
    }
    function closeModal() {
      modal.classList.remove('open');
      document.removeEventListener('keydown', onKeydown);
      setTimeout(function () { modal.hidden = true; }, 250);
      if (lastFocus) lastFocus.focus();
    }
    function onKeydown(e) {
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key !== 'Tab') return;
      var f = $$(FOCUSABLE, modal).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-sizeguide]')) { e.preventDefault(); openModal(); }
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-close-sizeguide]')) closeModal();
    });
  }

  /* ---------------------------------------------------------------------- */
  /* 9. Gallery thumbnail fallback (only when slick hasn't initialised)       */
  /* ---------------------------------------------------------------------- */
  var mainStage = $('.js_prod_main');
  $$('.engoj-nav-item').forEach(function (thumb) {
    function swap() {
      if (mainStage && mainStage.classList.contains('slick-initialized')) return; // let slick drive
      var tImg = thumb.querySelector('img');
      var mImg = $('.engoj_img_main');
      if (tImg && mImg) {
        var src = tImg.getAttribute('data-src') || tImg.src;
        mImg.src = src.replace('_160x', '_1200x').replace('160x', '1200x');
      }
      $$('.engoj-nav-item').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    }
    thumb.addEventListener('click', swap);
    thumb.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); swap(); }
    });
  });

  /* ---------------------------------------------------------------------- */
  /* 10. Sticky add-to-cart bar (reveals once the main ATC scrolls away)      */
  /* ---------------------------------------------------------------------- */
  // Keep the sticky bar's variant id in sync with the current selection so it
  // never adds a stale variant (Shopify.OptionSelectors updates #productSelect).
  var productSelect = document.getElementById('productSelect');
  var stickyId = document.querySelector('#sticky-add-to-cart-form input[name="id"]');
  if (productSelect && stickyId) {
    productSelect.addEventListener('change', function () { stickyId.value = productSelect.value; });
  }

  var stickyBar = $('.sticky_addcart');
  var mainAtc = $('.pdp-cart-row .add-to-cart-change');
  if (stickyBar && mainAtc && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -40px 0px' });
    io.observe(mainAtc);
  }

  /* ---------------------------------------------------------------------- */
  /* 11. Smooth-scroll reviews anchor + Judge.me "Write a review" passthrough */
  /* ---------------------------------------------------------------------- */
  root.addEventListener('click', function (e) {
    var a = e.target.closest('.pdp-reviews-anchor');
    if (a) {
      var target = document.getElementById('reviews') || document.getElementById('judgeme_product_reviews');
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }
    if (e.target.closest('[data-jdgm-write]')) {
      var writeLink = document.querySelector('.jdgm-write-rev-link');
      if (writeLink) { writeLink.click(); }
      else {
        var rv = document.getElementById('judgeme_product_reviews');
        if (rv) rv.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });
})();
